<script setup>
import { ref } from 'vue';
import { useStore } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

const props = defineProps({
  entity: {
    type: Object,
    required: true,
  },
  title: {
    type: String,
    default: 'Excluir',
  },
  description: {
    type: String,
    default: 'Tem certeza que deseja excluir este item?',
  },
  confirmButtonLabel: {
    type: String,
    default: 'Excluir',
  },
});

const emit = defineEmits(['deleteSuccess']);

const store = useStore();
const deleteDialogRef = ref(null);

const handleDialogConfirm = async () => {
  try {
    await store.dispatch('aifocusAgents/delete', props.entity.id);
    emit('deleteSuccess');
    useAlert('Agente excluido com sucesso');
  } catch (error) {
    useAlert(error?.message || 'Erro ao excluir agente');
  }
  deleteDialogRef.value?.close();
};

defineExpose({ dialogRef: deleteDialogRef });
</script>

<template>
  <Dialog
    ref="deleteDialogRef"
    type="alert"
    :title="title"
    :description="description"
    :confirm-button-label="confirmButtonLabel"
    @confirm="handleDialogConfirm"
  />
</template>
